import { createSelector } from 'reselect'
import { getValueCurrencySelector } from 'modules/currencies/selectors'
import { getSubTotalWithDiscountsCartSelector } from 'modules/cart/selectors/get-sub-total-with-discount'

const CART_FREE_SHIPPING_PRICE = 50

function isEligibleForFreeShippingCartSelector () {
  return createSelector(
    getSubTotalWithDiscountsCartSelector(),
    getValueCurrencySelector(),
    (subTotalWithDiscount, currencyValue) => {
      return (subTotalWithDiscount / currencyValue) > CART_FREE_SHIPPING_PRICE
    }
  )
}

function getFreeShippingMinPriceCartSelector () {
  return createSelector(
    getValueCurrencySelector(),
    (currencyValue) => {
      return currencyValue * CART_FREE_SHIPPING_PRICE
    }
  )
}

export {
  isEligibleForFreeShippingCartSelector,
  getFreeShippingMinPriceCartSelector,
  CART_FREE_SHIPPING_PRICE
}
